import EntityStatus from "go-list/core/components/Table/components/EntityStatus";

interface Props {
	status?: string;
}

const AppEntityStatus = ({ status }: Props) => {
	let entityStatus = "";
	switch (status) {
		case "ENABLED":
			entityStatus = "ENABLED";
			break;
		case "DISABLED":
		case "REMOVED":
			entityStatus = "DISABLED";
			break;
		case "WARNING":
			entityStatus = "WARNING";
			break;
	}
	return <EntityStatus status={entityStatus} />;
};

export default AppEntityStatus;
